import { useDispatch, useSelector, useStore } from "react-redux";
import {
	saveStreamMarker as saveStreamMarkerAction,
	deleteStreamMarker as deleteStreamMarkerAction,
	saveStream as saveStreamAction,
	deleteStream as deleteStreamAction,
	getStreams as getStreamsAction,
	initStreamData as initStreamDataAction,
	getProviderSrc as getProviderSrcAction,
	toggleStreamOpen as toggleStreamOpenAction,
	setTimeSkip as setTimeSkipAction,
	resetTimeSkip as resetTimeSkipAction,
	setPopoutOpen as setPopoutOpenAction,
	setPopoutClosed as setPopoutClosedAction
} from "./actions";
import { useAppContext } from "../app/context";

const useStreamContext = () => {
	const dispatch = useDispatch();
	const { redirect } = useAppContext();
	const store = useStore();

	const useIsLoading = () => useSelector((state) => state.stream.isLoading);

	const useStreams = () => useSelector((state) => state.stream.streams);

	const useOpen = () => useSelector((state) => state.stream.open);

	const useTimeSkip = () => useSelector((state) => state.stream.timeSkip);

	const usePopoutOpen = () => useSelector((state) => state.stream.popoutOpen);

	const state = {
		streams: useStreams,
		isLoading: useIsLoading,
		open: useOpen,
		timeSkip: useTimeSkip,
		popoutOpen: usePopoutOpen
	};

	const initStreamData = (eventId) => {
		initStreamDataAction(eventId, redirect, dispatch);
	};

	const saveStreamMarker = (streamId, marker) => {
		const { currentEvent } = store.getState().events;
		saveStreamMarkerAction(currentEvent.id, streamId, marker, dispatch);
	};

	const deleteStreamMarker = (streamId, markerId) => {
		const { currentEvent } = store.getState().events;
		deleteStreamMarkerAction(currentEvent.id, streamId, markerId, dispatch);
	};

	const saveStream = (stream) => {
		const { currentEvent } = store.getState().events;
		saveStreamAction(currentEvent.id, stream, dispatch);
	};

	const deleteStream = (streamId) => {
		const { currentEvent } = store.getState().events;
		deleteStreamAction(currentEvent.id, streamId, dispatch);
	};

	const getStreams = (eventId) => {
		getStreamsAction(eventId, dispatch);
	};

	const getProviderSrc = (streamId) => {
		const { streams } = store.getState().stream;
		const stream = streams.find((s) => s.id === streamId) || {};
		if (stream) {
			getProviderSrcAction(stream, dispatch);
		}
	};

	const toggleStreamOpen = (open) => {
		const { eventId } = store.getState().stream;
		toggleStreamOpenAction(open, eventId, dispatch);
	};

	const setTimeSkip = (seconds, streamId) => {
		const { currentEvent } = store.getState().events;
		const { popoutOpen } = store.getState().stream;
		setTimeSkipAction(seconds, streamId, currentEvent, popoutOpen, dispatch);
	};

	const resetTimeSkip = () => {
		const { currentEvent } = store.getState().events;
		resetTimeSkipAction(currentEvent.id, dispatch);
	};

	const setPopoutOpen = () => {
		const { currentEvent } = store.getState().events;
		setPopoutOpenAction(currentEvent.id, dispatch);
	};

	const setPopoutClosed = () => {
		const { currentEvent } = store.getState().events;
		setPopoutClosedAction(currentEvent.id, dispatch);
	};

	return {
		state,
		saveStreamMarker,
		deleteStreamMarker,
		saveStream,
		deleteStream,
		getStreams,
		initStreamData,
		getProviderSrc,
		toggleStreamOpen,
		setTimeSkip,
		resetTimeSkip,
		setPopoutOpen,
		setPopoutClosed
	};
};

export { useStreamContext };
